import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/reducer';
import { CartItem } from '@features/product/types';

export interface OrderState {
  cartItems: CartItem[];
}

export const initialState: OrderState = {
  cartItems: [],
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setCartItems: (state, { payload }: PayloadAction<CartItem[]>) => {
      state.cartItems = payload;
    },
    clearCart: (state) => {
      state.cartItems = [];
    },
    addToCart: (state, { payload }: PayloadAction<CartItem>) => {
      state.cartItems = [...(state?.cartItems ?? []), payload];
    },
    removeFromCart: (state, { payload }: PayloadAction<string>) => {
      state.cartItems = state.cartItems.filter((item) => item._id !== payload);
    },
  },
});

export const sliceActions = orderSlice.actions;
export const orderReducer = orderSlice.reducer;
export const orderSelector = (state: RootState) => state.order;
